/* eslint-disable no-prototype-builtins */
import { AvatarPrediction, BlendShapes, BlendShapeKeys } from '@quarkworks-inc/avatar-webkit';
import { LoadingState } from '@/_models/virtualStaging/VSObject';
import { findObject3DChildByName } from './utils';
import AbstractAvatar from './AbstractAvatar';

export class AvatarComponent extends AbstractAvatar {
  private avatarRoot: any;

  private faceNode?: any; // nodes for current RPM version

  private teethNode?: any;

  private wolf3DAvatar?: any; // nodes for old RPM versions

  async onInit() {
    if (!this.inputs.url?.length) return;
    this.outputs.loadingState = LoadingState.Loading;

    const THREE = this.context.three;
    this.initRoot();

    this.model = await this.loadModel(THREE, this.inputs.url);
    this.model.position.setY(-0.6);

    [this.avatarRoot] = this.model.children;
    this.faceNode = findObject3DChildByName(this.avatarRoot, 'Wolf3D_Head');
    this.teethNode = findObject3DChildByName(this.avatarRoot, 'Wolf3D_Teeth');
    this.wolf3DAvatar = findObject3DChildByName(this.avatarRoot, 'Wolf3D_Avatar');
    // console.log('this.avatarRoot', this.avatarRoot);
    // console.log('this.faceNode', this.faceNode);
    // console.log('this.teethNode', this.teethNode);
    // console.log('this.wolf3DAvatar', this.wolf3DAvatar);

    this.pivot.add(this.model);
    this.initLabel();

    this.outputs.loadingState = LoadingState.Loaded;
  }

  onDestroy() {
    if (this.label) {
      this.label.geometry.dispose();
      this.label.material.dispose();
    }
  }

  // called back when any inputs properties change
  onInputsUpdated() {
    this.onInit();
  }

  updateFromResults(prediction: AvatarPrediction) {
    if (!this.model) return;

    this.updateMorphTargets(prediction.blendShapes);
    this.updateHeadRotation(-prediction.rotation.pitch, -prediction.rotation.yaw, -prediction.rotation.roll);
    this.updatePosition(prediction.transform.x, prediction.transform.y, prediction.transform.z);
  }

  private updateMorphTargets(blendShapes: BlendShapes) {
    for (const key in blendShapes) {
      // RPM uses the ARKit key convention ("mouthSmileLeft" as opposed to "mouthSmile_L")
      const arKitKey = BlendShapeKeys.toARKitConvention(key);

      // Need to set all morphtargets for both meshes
      // ex. only setting jaw open for wolf3DAvatar will result in the mesh mouth opening but not the bones movingss1
      this.setMorphTarget(this.faceNode, arKitKey, blendShapes[key]);
      this.setMorphTarget(this.teethNode, arKitKey, blendShapes[key]);
      this.setMorphTarget(this.wolf3DAvatar, arKitKey, blendShapes[key]);
    }
  }

  private setMorphTarget = (mesh: any | undefined, key: string, value: any) => {
    if (!mesh) return;
    const idx = mesh.morphTargetDictionary[key];
    if (!idx) return;
    mesh.morphTargetInfluences[idx] = value;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this
  private updateHeadRotation(pitch: number, yaw: number, roll: number) {
    // Inverse yaw & roll effects for yourself to give mirror effect
    this.pivot.rotation.set(pitch, yaw, roll);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this
  private updatePosition(x: number, y: number, z: number) {
    // const SCALE = 0.2;
    // const Y_OFFSET = 0;
    // this.avatarRoot?.position.set(x * SCALE, Y_OFFSET + y * SCALE, z);
  }
}

export const avatarComponentType = 'mp.avatarComponent';
export const makeAvatarComponent = () => new AvatarComponent();
